import React from "react";
import { Col, Row } from "react-bootstrap";
import * as SiIcons from "react-icons/si";
import tls from "../../tools.json";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tls.Tools.map((tool) => {
        const IconComponent = SiIcons[tool.icon];
        return (
          <Col xs={4} md={2} className="tech-icons">
            {IconComponent && <IconComponent />}
          </Col>
        );
      })}
    </Row>
  );
}

export default Toolstack;
